// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a063d76d","453":"489e401b","455":"2f7d5981","977":"f02d0923"}[chunkId] + ".chunk.js";
};